// Generated by purs version 0.13.0
"use strict";
var Data_Eq = require("../Data.Eq/index.js");
var On = (function () {
    function On() {

    };
    On.value = new On();
    return On;
})();
var Off = (function () {
    function Off() {

    };
    Off.value = new Off();
    return Off;
})();
var eqSwitchState = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof On && y instanceof On) {
            return true;
        };
        if (x instanceof Off && y instanceof Off) {
            return true;
        };
        return false;
    };
});
module.exports = {
    On: On,
    Off: Off,
    eqSwitchState: eqSwitchState
};
